import Vue from 'vue';
import { MutationTree } from 'vuex';

import { EditableStatus } from '@/store/types';
import { updateEditable } from '@/store/utils/editable';

import { RegionsState, RegionsMutations } from './types';
import Region from '@/store/models/region';

const mutations: MutationTree<RegionsState> = {
  /**
   * Edit
   */
  [RegionsMutations.SET_EDITABLE](state, regions: Region[]) {
    Vue.set(state, 'editable', regions);
    Vue.set(state, 'initialEditable', regions.map((region) => Region.clone(region)));
  },
  [RegionsMutations.SET_EDITABLE_STATUS](state, editableStatus: EditableStatus) {
    state.editableStatus = editableStatus;
  },
  [RegionsMutations.UPDATE_EDITABLE]: updateEditable<RegionsState>('editable'),
  [RegionsMutations.UPDATE_INITIAL_EDITABLE]: updateEditable<RegionsState>('initialEditable'),
};

export default mutations;
